import { v4 as uuidv4 } from "uuid";
import supportImagePlaceholder from "@circle-react-shared/BuilderUI/Assets/icons/support_image_placeholder.png";
import userImagePlaceholder from "@circle-react-shared/BuilderUI/Assets/icons/user_image_placeholder.png";
import usersImagePlaceholder from "@circle-react-shared/BuilderUI/Assets/icons/users_image_placeholder.png";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { createCardBlock } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/layoutBlockHelpers/cardBlockHelper";
import { getBlockPrimaryStyleOptions } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/stylesHelpers";
import {
  createH2Block,
  createPBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import {
  getBackgroundColorOptions,
  getBorderColorOptions,
} from "@circle-react-shared/BuilderUI/utils/buttonStyleHelpers";

const cards = [
  {
    image: {
      signedId: "",
      placeholder: userImagePlaceholder,
    },
    h5Text: "Curriculum coaching",
    pText:
      "Work 1:1 with a strategist to map your learning outcomes, structure your course, and translate your expertise into a journey students can truly complete.",
  },
  {
    image: {
      signedId: "",
      placeholder: usersImagePlaceholder,
    },
    h5Text: "Program design labs",
    pText:
      "Join small-group, feedback-driven labs to shape your course, test your delivery flow, and sharpen your offer alongside aligned creators.",
  },
  {
    image: {
      signedId: "",
      placeholder: supportImagePlaceholder,
    },
    h5Text: "Accountability circles",
    pText:
      "Stay consistent with curated peer pods, live Q&A touchpoints, and a supportive community focused on clarity, momentum, and purpose-driven teaching.",
  },
] as const;

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "EvergreenHomepageBlock2",
  props: {
    header: {
      prop: "children",
      type: "children",
      value: [
        createH2Block({
          text: "Transform your leadership with coaching",
        }),
        createPBlock({
          text: "Get personalized coaching, participate in mastermind discussions, and connect with peers who challenge and support your growth.",
        }),
      ],
    },
    content: {
      prop: "children",
      type: "children",
      value: cards.map(card =>
        createCardBlock({
          ...card,
          styles: {
            backgroundColor: getBackgroundColorOptions({
              defaultValue: "var(--theme-website-color-2)",
            }),
            borderColor: getBorderColorOptions({
              defaultValue: "var(--theme-website-color-1)",
            }),
          },
        }),
      ),
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        ...getBlockPrimaryStyleOptions(),
      },
    },
  },
};
